import { useEffect, useState } from "react";
import { Button, Group, Modal, Paper, Text, createStyles } from "@mantine/core";
import { ResourceBlame, ResourceForm, useMedplum } from "@medplum/react";
import { normalizeErrorString } from "@medplum/core";
import { useNavigate, useParams } from "react-router-dom";
import { showNotification } from "@mantine/notifications";

const useStyles = createStyles(() => ({
  default: {
    padding: "30px",
    borderRadius: "8px",
    margin: "40px",
    background: "'#FFF",
    boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
    width: "100%",
  },
  text: { border: "1px solid #ddd", borderRadius: "5px", padding: "12px" },
}));
interface FhirJsonProps {
  resourceType?: any;
}

export const FhirJson: React.FC<FhirJsonProps> =({resourceType})=> {
      const { classes } = useStyles();

  const medplum = useMedplum();
  const { Id } = useParams();
  const navigate = useNavigate();
  const [patientDetails, setPatientDetails] = useState<any>({});
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);

  useEffect(() => {
    getPatientDetails();
  }, [medplum]);

  const getPatientDetails = () => {
    medplum
      .readResource(resourceType, Id as any)
      .then((res: any) => {
        setPatientDetails(res);
      });
  };

 

  return (
    <>
      <Paper
       className={classes.default}
      >
        <Text size={"xl"} fw={700} mb={"md"}>
          FHIR Response
        </Text>
        <Text
         className={classes.text}
        >
          <pre>{JSON.stringify(patientDetails, null, 2)}</pre>
        </Text>

      </Paper>
    </>
  );
}
